import { useFormik } from "formik"
import { t } from "i18next"
import React, { useEffect, useState } from "react"
import SVG from "react-inlinesvg"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import swal from "sweetalert"
import * as Yup from "yup"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/index.js"
import { useHtmlClassService } from "../../../../_metronic/layout"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { KPI_GOAL_SETTING_TAB } from "../../../../constants/StringConstant.js"
import { submitSettingTargetRegional } from "../../../../redux/actions/FieldOfficerAction.jsx"
import { fetchPlants, getDetailRegional } from "../../../../redux/actions/MasterDataAction"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import { useParams } from "react-router-dom"

export function useSettingTargetPage() {
  const uiService = useHtmlClassService()
  const dispatch = useDispatch()
  const { MasterData, General } = useSelector((state) => state)
  const {regional} = useParams()
  const user = loadUserLogin()
  const regionalId = regional || user?.regional_id
  const history = useHistory()

  const [dataTargetRegional, setDataTargetRegional] = useState([])
  const [activeStep, setActiveStep] = useState(0)
  const [activeForm, setActiveForm] = useState(0)
  const [listSubRegional, setListSubRegional] = useState([])
  const [isDoneRegionalForm, setIsDoneRegionalForm] = useState(false)
  const [groupSubRegional, setGroupSubRegional] = useState([])
  const [isPreviewSubRegional, setIsPreviewSubRegional] = useState(false)
  const [isDoneSubRegional, setIsDoneSubRegional] = useState(false)
  const [isValidCheck, setIsValidCheck] = useState(false)
  const [totalSumTargetSubRegional, setTotalSumTargetSubRegional] = useState([0, 0, 0])

  function checkLabel(idx) {
    switch (idx) {
      case 0:
        return "Padi"
      case 1:
        return "Jagung"
      default:
        return "Jagung produksi"
    }
  }

  const labelStep = [t("label_input_target"), t("label_preview")]
  const validationSchema = Yup.object().shape({
    target: Yup.array().of(
      Yup.object().shape({
        value: Yup.number()
          .typeError("Harus berupa angka yang valid")
          .integer("Tidak boleh menggunakan angka desimal")
          .test("not-over-total", function (val) {
            const index = this.options.index
            const max = totalSumTargetSubRegional?.[index]
            if (val >= max) return true
            return this.createError({
              message: `Target kurang dari Total Sub Regional (${checkLabel(index)} ${max} Ha)`
            })
          })
          .required("Value harus diisi")
      })
    ),
    sub_regionals: Yup.array().of(
      Yup.object().shape({
        target: Yup.array().of(
          Yup.object().shape({
            value: Yup.number()
              .typeError("Harus berupa angka yang valid")
              .integer("Tidak boleh menggunakan angka desimal")
              .when("label", {
                is: (label) => label !== undefined,
                then: Yup.number().required("Value harus diisi")
              })
          })
        )
      })
    )
  })

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      year: new Date().getFullYear(),
      target: [],
      sub_regionals: []
    },
    onSubmit: (value) => {
      const data = {
        year: value.year,
        regional: value.target.map((item) => {
          return {
            plant_type_id: item.plant_type_id,
            value: parseInt(item.value)
          }
        }),
        sub_regionals: value.sub_regionals.map((item) => {
          return {
            id: item.id,
            target: item.target.map((e) => {
              return {
                plant_type_id: e.plant_type_id,
                value: parseInt(e.value)
              }
            })
          }
        })
      }
      dispatch(submitSettingTargetRegional(regionalId, data))
    }
  })

  useEffect(() => {
    const dataTarget = formik.values.sub_regionals

    if (dataTarget && dataTarget.length > 0) {
      const sliceTarget = dataTarget.map((regional) => {
        if (!regional || !Array.isArray(regional.target)) return [0, 0, 0]

        return regional.target.map((item) => (item?.value ? parseInt(item.value) : 0))
      })

      const result = sliceTarget.reduce(
        (acc, item) => {
          for (let i = 0; i < 3; i++) {
            acc[i] += item[i] ?? 0
          }
          return acc
        },
        [0, 0, 0]
      )

      setTotalSumTargetSubRegional(result)
    }
  }, [formik.values])

  useEffect(() => {
    if (General?.isFinishUpdateOrDelete)
      swal({
        text: t("messages_response_success_setting_target_regional_and_sub_regional"),
        icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_SETTING_TARGET)
      }).then(() => {
        history.push(RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(regionalId, KPI_GOAL_SETTING_TAB.THIS_YEAR, new Date().getFullYear()))
      })
  }, [General?.isFinishUpdateOrDelete])

  function checkDisableButtonRegional() {
    if (formik.touched.target) {
      return !!formik.errors.target
    } else {
      return true
    }
  }
  function checkDisableButtonSubRegional() {
    const data = formik.values.sub_regionals || []

    if (data.length === 0) return true

    for (const item of data) {
      for (const target of item.target) {
        const val = parseInt(target.value)
        if (isNaN(val) || val < 0) {
          return true
        }
      }
    }

    const hasError = checkHasSubRegionalErrors(formik.errors)
    if (hasError) return true
    return !checkValue()
  }

  function checkHasSubRegionalErrors(errors) {
    if (!errors?.sub_regionals) return false

    for (const item of errors.sub_regionals) {
      if (item && item.target) {
        for (const target of item.target) {
          if (target?.value) return true
        }
      }
    }

    return false
  }
  useEffect(() => {
    const data = formik.values?.sub_regionals
    if (!data) return
    const grouped = data
      .flatMap((item) => item.target)
      .reduce((acc, curr) => {
        const id = curr.plant_type_id
        const value = Number(curr?.value || 0)

        if (!acc[id]) {
          acc[id] = { plant_type_id: id, label: curr.label, value: 0 }
        }
        acc[id].value += value
        return acc
      }, {})
    if (!grouped) return
    const result = Object.values(grouped)
    setGroupSubRegional(result)
  }, [formik.values?.sub_regionals])

  function showToastValidationSubRegional() {
    toast(t("label_note_view_setting_target_sub_regional_description"), {
      position: "top-center",
      autoClose: 5000,
      className: "bg-neutral-black",
      icon: <SVG src={ICON_CONSTANTS.BULLET_CLOSE_RED} />,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "dark"
    })
  }

  useEffect(() => {
    uiService.setFullPage()
    return () => {
      uiService.setExitFullPage()
    }
  }, [])

  useEffect(() => {
    if (regionalId) {
      dispatch(fetchPlants({
        use_metrics: true
      }))
      dispatch(getDetailRegional(regionalId))
    }
  }, [])

  function onResetRegionalForm() {
    if (!MasterData?.plantList) return
    const data = MasterData?.plantList
    const formData = data.map((item) => {
      return {
        plant_type_id: item.id,
        label: item.name,
        value: 0
      }
    })
    formik.setFieldValue("target", formData)
  }
  useEffect(() => {
    if (activeForm !== 1) {
      setIsValidCheck(false)
      return
    }

    const handler = setTimeout(() => {
      const isValid = checkValue()
      setIsValidCheck(isValid)

      if (!isValid) {
        showToastValidationSubRegional()
      }
    }, 500)

    return () => clearTimeout(handler)
  }, [groupSubRegional, activeForm, formik.values.target])

  function checkValue() {
    const regional = formik.values?.target || []
    const subRegional = groupSubRegional || []

    const regionalMap = regional.reduce((acc, curr) => {
      acc[curr.plant_type_id] = parseInt(curr?.value || 0)
      return acc
    }, {})
    return subRegional.every((item) => Number(item.value) <= regionalMap[item.plant_type_id])
  }
  function buildTargetSubRegional() {
    const data = MasterData?.plantList
    return data.map((item) => {
      return {
        plant_type_id: item.id,
        value: undefined,
        label: item.name
      }
    })
  }
  useEffect(() => {
    if (MasterData?.detailRegional && MasterData?.plantList) {
      const data = MasterData?.detailRegional?.list_sub_regional
      if (data) {
        setListSubRegional(data)
        const formDataSubRegional = data.map((item) => {
          return {
            id: item.id,
            regency_list: item.regency_list,
            name: item.name,
            target: buildTargetSubRegional()
          }
        })
        formik.setFieldValue("sub_regionals", formDataSubRegional)
      }
      if (MasterData?.plantList) {
        const dataPlant = MasterData?.plantList
        const formData = dataPlant.map((item) => {
          return {
            plant_type_id: item.id,
            label: item.name,
            value: ""
          }
        })
        formik.setFieldValue("target", formData)
      }
    }
  }, [MasterData?.detailRegional, MasterData?.plantList])

  function onNextFormRegional() {
    setIsDoneRegionalForm(true)
    setDataTargetRegional(formik.values.target)
    setActiveForm(1)
  }

  function onSubmitSubRegional() {
    setIsPreviewSubRegional(true)
    setIsDoneSubRegional(true)
  }

  function onClickEditSubRegional() {
    if (isDoneSubRegional) {
      setIsDoneSubRegional(false)
      setActiveForm(1)
      setIsPreviewSubRegional(false)
    }
  }

  function onResetSubRegional() {
    const data = formik.values?.sub_regionals.map((item) => {
      return {
        ...item,
        target: item.target.map((e) => {
          return {
            ...e,
            value: 0
          }
        })
      }
    })
    formik.setFieldValue("sub_regionals", data)
  }

  function checkDisableButtonSubmiFinal() {
    if (isValidCheck) {
      return !isPreviewSubRegional
    } else {
      return true
    }
  }

  return {
    uiService,
    labelStep,
    activeStep,
    setActiveStep,
    isDoneSubRegional,
    isPreviewSubRegional,
    formik,
    activeForm,
    dataTargetRegional,
    onNextFormRegional,
    onResetSubRegional,
    isDoneRegionalForm,
    setActiveForm,
    listSubRegional,
    groupSubRegional,
    onClickEditSubRegional,
    onSubmitSubRegional,
    checkDisableButtonRegional,
    checkDisableButtonSubmiFinal,
    onResetRegionalForm,
    checkDisableButtonSubRegional,
    checkValue,
    isValidCheck
  }
}
